import UserAuthProvider from './userAuth.provider'

export default UserAuthProvider
